export namespace MarkEvents {
  export const MVP0_TEXT_ENTRY_TEXT_CHANGED: string = "mvp0:textentry:text-changed";

}

